import packageJson from '../package.json';
import agentStatus from '../.agents/STATUS.md?raw';

const releaseVersion = import.meta.env.VITE_APP_VERSION || packageJson.version;
const stageFromStatus = agentStatus.match(/Current development stage:\s*Stage\s+(\d+)/i)?.[1];
const stage = import.meta.env.VITE_APP_STAGE || stageFromStatus || 'unknown';

export const APP_VERSION_LABEL = `v${releaseVersion}`;
export const APP_STAGE_LABEL = stage === 'unknown' ? 'Stage ?' : `Stage ${stage}`;
export const APP_RELEASE_STAMP = `${APP_VERSION_LABEL}  ·  ${APP_STAGE_LABEL}`;
